<template>
  <!-- LOADING -->
  <header v-if="loading || onboarding === undefined || forbidden === undefined || admin"></header>

  <!-- ONBOARDING / FORBIDDEN -->
  <header v-else-if="onboarding || forbidden" class="absolute inset-x-0 top-0">
    <nav class="mx-auto flex max-w-7xl items-center justify-center p-6 lg:px-8" aria-label="Global">
      <div class="flex items-center gap-x-3">
        <!-- <a href="" class="-m-1.5 p-1.5"> -->
          <object class="h-8 w-auto pointer-events-none" :data="logoImage" type="image/svg+xml"></object>
        <!-- </a> -->
      </div>
    </nav>
  </header>

  <!-- DATA PAGES -->
  <header v-else-if="data" class="absolute inset-x-0 top-0 max-h-20 flex flex-row items-center justify-between p-4 pb-2">
    <div class="flex flex-col items-stretch w-full">
      <div class="flex flex-col items-center">
        <h2>{{ dataPage }}</h2>
      </div>
      <div class="h-1 border-b border-grey-300"></div>
    </div>
    <div></div>
  </header>

  <!-- TOOLKIT PAGE -->
  <header v-else-if="toolkit" class="absolute inset-x-0 top-0 max-h-20 flex flex-row items-center justify-between p-4 pb-2">
    <img @click="$router.go(-1)" src="@/assets/chevron_left.png" class="absolute h-8 mb-2 opacity-50">
    <div class="flex flex-col items-cente w-full">
      <div class="flex flex-col items-center">
        <h2>Toolkit</h2>
      </div>
      <div class="h-1 border-b border-grey-300"></div>
    </div>
    <div></div>
  </header>

  <!-- PLAN PAGES -->
  <header v-else-if="plan" class="absolute inset-x-0 top-0 max-h-20 flex flex-row items-center justify-between p-4 pb-2">
    <img @click="$router.go(-1)" src="@/assets/chevron_left.png" class="absolute h-8 mb-2 opacity-50">
    <div class="flex flex-col items-cente w-full">
      <div class="flex flex-col items-center">
        <h2>{{ planPage }}</h2>
      </div>
      <div class="h-1 border-b border-grey-300"></div>
    </div>
    <div></div>
  </header>

  <!-- HOME -->
  <header v-else class="absolute inset-x-0 top-0 max-h-20 flex flex-row items-center justify-between p-4 pb-2">
    <div class="flex flex-col items-stretch w-full">
      <div class="flex flex-col items-center">
        <h2>Hi <span class="font-bold">{{ userStore.user?.name }}</span>!</h2>
      </div>
      <div class="h-1 border-b border-grey-300"></div>
      <!-- <div class="text-sm">24 OCTOBER</div> -->
      <!-- <div class="text-3xl font-medium">Thursday</div> -->
    </div>
    <div></div>
  </header>
</template>

<script>
import { mapStores } from 'pinia'
import { useUserStore } from '@/stores/user'

export default {
  name: 'AppHeader',
  data() {
    return {
      logoImage: require('@/assets/logo.svg'),
      loading: true,
    }
  },
  beforeMount() {
  },
  watch:{
    async $route() {
      this.loading = false
    },
  },
  methods: {
    caps(s) {
      return String(s).charAt(0).toUpperCase() + String(s).slice(1);
    },
  },
  computed: {
    onboarding() {
      return (this.$route.path.startsWith('/onboarding')
        || this.$route.path.startsWith('/login'))
    },
    forbidden() {
      return this.$route.path.startsWith('/forbidden')
    },
    data() {
      return this.$route.path.startsWith('/data')
    },
    dataPage() {
      if (!this.data) return
      const regex = /data\/(.*)/.exec(this.$route.path)
      return this.caps(regex[1])
    },
    toolkit() {
      return this.$route.path.startsWith('/toolkit')
    },
    plan() {
      return this.$route.path.startsWith('/plan')
    },
    planPage() {
      return this.$route.name || ''
    },
    admin() {
      return this.$route.path.startsWith('/admin')
    },
    ...mapStores(useUserStore),
  },
}
</script>